module.exports = __webpack_public_path__ + "assets/manyPoints.fe74a54c.svg";